import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';

// Props
// isOpen                    (bool)
// onClose                   (function)
// isCloseable               (bool)
// isFullScreen              (bool)
// noHeader                  (bool)
// title                     (string)
// maxWidth                  (string)  default 'xs'
// id                        (string)
// className                 (string)
// primaryButtonTitle        (string)
// onPrimaryClick            (function)
// isPrimaryButtonDisabled   (bool)
// secondaryButtonTitle      (string)
// onSecondaryClick          (function)
// isSecondaryButtonDisabled (bool)
// children

function MssModal({
  isOpen,
  onClose,
  isCloseable = true,
  isFullScreen,
  noHeader = false,
  title,
  maxWidth = 'xs',
  id,
  className,
  primaryButtonTitle,
  onPrimaryClick,
  isPrimaryButtonDisabled,
  secondaryButtonTitle,
  onSecondaryClick,
  isSecondaryButtonDisabled,
  children,
}) {
  const modalClass = ['mss__modal', noHeader ? 'noHeader' : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  const hasActions = primaryButtonTitle || secondaryButtonTitle;

  return (
    <Dialog
      open={isOpen}
      onClose={isCloseable ? onClose : undefined}
      fullWidth
      fullScreen={isFullScreen}
      maxWidth={maxWidth}
      className={modalClass}
      id={id}
    >
      <DialogTitle>
        <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          {title && (
            <Typography variant="h5" component="h2">
              {title}
            </Typography>
          )}
          {isCloseable && (
            <IconButton
              aria-label="close"
              onClick={onClose}
              className="mss__closeX mss__iconButton"
              id={id ? `${id}__button_close` : undefined}
            >
              <FontAwesomeIcon icon={faXmark} fixedWidth size="xs" />
            </IconButton>
          )}
        </Stack>
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      {hasActions && (
        <DialogActions style={{ padding: '1rem', paddingTop: 0 }}>
          <Stack
            sx={{ width: '100%', alignItems: 'center', justifyContent: 'end' }}
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
          >
            {secondaryButtonTitle && (
              <Button
                variant="contained"
                className="mss__button modalActionButton"
                onClick={onSecondaryClick}
                disabled={isSecondaryButtonDisabled ?? false}
                id={id ? `${id}__button_secondary` : undefined}
              >
                {secondaryButtonTitle}
              </Button>
            )}
            {primaryButtonTitle && (
              <Button
                variant="contained"
                className="mss__button primary modalActionButton"
                onClick={onPrimaryClick}
                disabled={isPrimaryButtonDisabled ?? false}
                id={id ? `${id}__button_primary` : undefined}
              >
                {primaryButtonTitle}
              </Button>
            )}
          </Stack>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default MssModal;
